export default [
  {
    path: "/categories",
    name: "categories",
    component: () => import("@/views/pages/categories/index.vue"),
    meta: {
      pageTitle: "دسته‌بندی محصولات",
    },
  },
  {
    path: "/products",
    name: "products",
    component: () => import("@/views/pages/products/index.vue"),
    meta: {
      pageTitle: "محصولات",
    },
  },
  {
    path: "/products/group-editing",
    name: "products-group-editing",
    component: () => import("@/views/pages/products/group-editing/index.vue"),
    meta: {
      pageTitle: "ویرایش گروهی محصولات",
    },
  },
  {
    path: "/waiter-requests",
    name: "waiter-requests",
    component: () => import("@/views/pages/waiter-requests/index.vue"),
    meta: {
      pageTitle: "درخواست‌های سالن‌دار",
    },
  },
  {
    path: "/identity-management",
    name: "identity-management",
    component: () => import("@/views/pages/identity-management/index.vue"),
    meta: {
      pageTitle: "اطلاعات مدیر",
    },
  },
  {
    path: "/basic-settings",
    name: "basic-settings",
    component: () => import("@/views/pages/basic-settings/index.vue"),
    meta: {
      pageTitle: "تنظیمات پایه",
    },
  },
  {
    path: "/table-settings",
    name: "table-settings",
    component: () => import("@/views/pages/table-settings/index.vue"),
    meta: {
      pageTitle: "تنظیمات جایگاه‌ها",
    },
  },
  {
    path: "/customer-club",
    name: "customer-club",
    component: () => import("@/views/pages/customer-club/index.vue"),
    meta: {
      pageTitle: "تنظیمات باشگاه مشتریان",
    },
  },
  {
    path: "/sms-management",
    name: "sms-management",
    component: () => import("@/views/pages/sms-management/index.vue"),
    meta: {
      pageTitle: "الگوهای پیامک سیستمی",
    },
  },
  {
    path: "/not-authorized",
    name: "not-authorized",
    component: () => import("@/views/pages/not-authorized/index.vue"),
  },
  {
    path: "/work-schedule",
    name: "work-schedule",
    component: () => import("@/views/pages/work-schedule/index.vue"),
    meta: {
      pageTitle: "تنظیمات ساعت کاری",
    },
  },
  {
    path: "/pictures-about-us",
    name: "pictures-about-us",
    component: () => import("@/views/pages/pictures-about-us/index.vue"),
    meta: {
      pageTitle: "تنظیمات تصاویر درباره ما",
    },
  },
  {
    path: "/user-management",
    name: "user-management",
    component: () => import("@/views/pages/user-management/index.vue"),
    meta: {
      pageTitle: "تنظیمات کارکنان",
    },
  },
  {
    path: "/printer-settings",
    name: "printer-settings",
    component: () => import("@/views/pages/printer-settings/index.vue"),
    meta: {
      pageTitle: "تنظیمات چاپگر",
    },
  },
  {
    path: "/subscription-management",
    name: "subscription-management",
    component: () => import("@/views/pages/subscription-management/index.vue"),
    meta: {
      pageTitle: "مدیریت اشتراک",
    },
  },
  {
    path: "/sms-send",
    name: "sms-send",
    component: () => import("@/views/pages/sms-send/index.vue"),
    meta: {
      pageTitle: "ارسال گروهی پیامک",
    },
  },
  {
    path: "/sms-send-management",
    name: "sms-send-management",
    component: () => import("@/views/pages/sms-send/management/index.vue"),
    meta: {
      pageTitle: "درخواست ارسال پیامک",
    },
  },
  {
    path: "/sms-account-report",
    name: "sms-account-report",
    component: () => import("@/views/pages/sms-account-report/index.vue"),
    meta: {
      pageTitle: "گزارش شارژ حساب پیامک",
    },
  },
  {
    path: "/sms-sent-messages",
    name: "sms-sent-messages",
    component: () => import("@/views/pages/sms-sent-messages/index.vue"),
    meta: {
      pageTitle: "گزارش ارسال پیامک",
    },
  },
  {
    path: "/transactions",
    name: "transactions",
    component: () => import("@/views/pages/transactions/index.vue"),
    meta: {
      pageTitle: "گزارش اشتراک",
    },
  },
  {
    path: "/redirect-to-gateway",
    name: "redirect-to-gateway",
    component: () => import("@/views/redirect-to-gateway/index.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/factor",
    name: "factor",
    component: () => import("@/views/pages/factor/index.vue"),
    meta: {
      pageTitle: "فاکتور",
    },
  },
  {
    path: "/tickets",
    name: "tickets",
    component: () => import("@/views/pages/tickets/index.vue"),
    meta: {
      pageTitle: "پشتیبانی",
    },
  },
  {
    path: "/tickets/details",
    name: "tickets-details",
    component: () => import("@/views/pages/tickets/details/index.vue"),
    meta: {
      pageTitle: "پشتیبانی",
    },
  },
  {
    path: "/activation-payment-gateway",
    name: "activation-payment-gateway",
    component: () =>
      import("@/views/pages/activation-payment-gateway/index.vue"),
    meta: {
      pageTitle: "فعال‌سازی درگاه پرداخت",
    },
  },
  {
    path: "/invoice-registration",
    name: "invoice-registration",
    component: () => import("@/views/pages/invoice-registration/index.vue"),
    meta: {
      pageTitle: "ثبت سفارش",
    },
  },
  {
    path: "/invoice-details",
    name: "invoice-details",
    component: () => import("@/views/pages/invoice-details/index.vue"),
    meta: {
      pageTitle: "جزئیات سفارش",
    },
  },
  {
    path: "/pre-invoice",
    name: "pre-invoice",
    component: () => import("@/views/pages/pre-invoice/index.vue"),
    meta: {
      pageTitle: "ثبت پیش‌سفارش",
    },
  },
  {
    path: "/daily-orders",
    name: "daily-orders",
    component: () => import("@/views/pages/daily-orders/index.vue"),
    meta: {
      pageTitle: "سفارشات روزانه",
    },
  },
  {
    path: "/daily-sales-report",
    name: "daily-sales-report",
    component: () => import("@/views/pages/daily-sales-report/index.vue"),
    meta: {
      pageTitle: "گزارش سفارشات",
    },
  },
  {
    path: "/customers",
    name: "customers",
    component: () => import("@/views/pages/customers/index.vue"),
    meta: {
      pageTitle: "مشتریان",
    },
  },
  {
    path: "/customers/orders-list",
    name: "customer-orders-list",
    component: () => import("@/views/pages/customers/orders-list/index.vue"),
    meta: {
      pageTitle: "لیست سفارشات مشتری",
    },
  },
  {
    path: "/online-orders",
    name: "online-orders",
    component: () => import("@/views/pages/online-orders/index.vue"),
    meta: {
      pageTitle: "گزارش سفارشات آنلاین",
    },
  },
  {
    path: "/product-orders",
    name: "product-orders",
    component: () => import("@/views/pages/product-orders/index.vue"),
    meta: {
      pageTitle: "گزارش فروش محصولات",
    },
  },
  {
    path: "/advanced-sales-report",
    name: "advanced-sales-report",
    component: () => import("@/views/pages/advanced-sales-report/index.vue"),
    meta: {
      pageTitle: "گزارش جامع سفارشات",
    },
  },
  {
    path: "/chef-invoice",
    name: "chef-invoice",
    component: () => import("@/views/pages/chef-invoice/index.vue"),
    meta: {
      pageTitle: "چاپگر خودکار سفارشات",
    },
  },
  {
    path: "/raw-material-category",
    name: "raw-material-category",
    component: () => import("@/views/pages/raw-material-category/index.vue"),
    meta: {
      pageTitle: "دسته‌بندی مواد اولیه",
    },
  },
  {
    path: "/raw-material",
    name: "raw-material",
    component: () => import("@/views/pages/raw-material/index.vue"),
    meta: {
      pageTitle: "مواد اولیه",
    },
  },
  {
    path: "/warehouses",
    name: "warehouses",
    component: () => import("@/views/pages/warehouses/index.vue"),
    meta: {
      pageTitle: "انبارها",
    },
  },
  {
    path: "/people",
    name: "people",
    component: () => import("@/views/pages/people/index.vue"),
    meta: {
      pageTitle: "اشخاص",
    },
  },
  {
    path: "/warehouse-invoice",
    name: "warehouse-invoice",
    component: () => import("@/views/pages/warehouse-invoice/index.vue"),
    meta: {
      pageTitle: "فاکتور انبار",
    },
  },
  {
    path: "/stock-taking",
    name: "stock-taking",
    component: () => import("@/views/pages/stock-taking/index.vue"),
    meta: {
      pageTitle: "انبارگردانی",
    },
  },
  {
    path: "/stock-movements",
    name: "stock-movements",
    component: () => import("@/views/pages/stock-movements/index.vue"),
    meta: {
      pageTitle: "گزارش ورود و خروج انبار",
    },
  },
  {
    path: "/score-management",
    name: "score-management",
    component: () => import("@/views/pages/score-management/index.vue"),
    meta: {
      pageTitle: "سطوح و امتیازات مشتریان",
    },
  },
  {
    path: "/credit-and-wallet",
    name: "credit-and-wallet",
    component: () => import("@/views/pages/credit-and-wallet/index.vue"),
    meta: {
      pageTitle: "اعتبار و کیف پول مشتریان",
    },
  },
  {
    path: "/ratings-and-comments",
    name: "ratings-and-comments",
    component: () => import("@/views/pages/ratings-and-comments/index.vue"),
    meta: {
      pageTitle: "امتیاز و نظرات مشتریان",
    },
  },
  {
    path: "/smart-campaigns",
    name: "smart-campaigns",
    component: () => import("@/views/pages/smart-campaigns/index.vue"),
    meta: {
      pageTitle: "کمپین‌های هوشمند",
    },
  },
];
